import HsIndividualResourceReferences from './component'
export default HsIndividualResourceReferences
